import RestaurantInfo from './RestaurantInfo';

export default RestaurantInfo;
